var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.2396 5.324L11.8842 5.32488C10.8213 5.32488 10.6152 5.81575 10.6152 6.53588V8.12488H13.1505L12.8202 10.6143H10.6152V17H7.97187V10.6143H5.76147V8.12488H7.97187V6.29C7.97187 4.15937 9.31017 3 11.2641 3C12.2001 3 13.0047 3.06737 13.2396 3.098V5.324Z","fill":"#4868AD"}));
}

Facebook.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
